import React from 'react';
import useBackendApi from '../../hooks/useBackendApi';

export default function useMediaContainerData({
  initialMediaItems = [],
  profileId,
  storeSlug,
  categorySlug,
  fetchMediaUrl = '',
  itemsPerPage = 4,
  hideLoader = false,
}: any) {
  const { get } = useBackendApi();

  const [mediaInfo, setMediaInfo] = React.useState<any>({
    media: initialMediaItems,
    totalMediaCount: 0,
  });

  React.useEffect(() => {
    const fetch = async () => {
      const res = await get(
        '/v1/media',
        {
          userProfileId: profileId,
          storeSlug,
          categorySlug,
          limit: itemsPerPage,
          page: 1,
        },
        { loader: !hideLoader }
      );

      const media = res.data.docs || [];
      const totalMediaCount = res.results;
      setMediaInfo({ media, totalMediaCount });
    };
    if ((profileId && storeSlug && categorySlug) || categorySlug) {
      fetch();
    }
  }, [profileId, storeSlug, categorySlug]);

  React.useEffect(() => {
    const fetch = async () => {
      const url = fetchMediaUrl;
      const res = await get(
        url,
        {
          limit: 4,
          page: 1,
        },
        { loader: !hideLoader }
      );

      const media = res.data.docs || [];
      const totalMediaCount = res.results;
      setMediaInfo({ media, totalMediaCount });
    };
    if (fetchMediaUrl) {
      fetch();
    }
  }, [fetchMediaUrl]);

  const fetchNextMediaSet = React.useCallback(
    async (idx: any) => {
      const { media, totalMediaCount } = mediaInfo;
      const itemsLength = media.length;

      if (itemsLength < totalMediaCount && idx + 2 === itemsLength) {
        const page = Math.floor(itemsLength / itemsPerPage) + 1;
        const res = await get(
          fetchMediaUrl || '/v1/media',
          {
            userProfileId: profileId,
            storeSlug: storeSlug,
            categorySlug: categorySlug,
            page,
            limit: itemsPerPage,
          },
          { loader: false }
        );
        setMediaInfo({ ...mediaInfo, media: [...media, ...res.data.docs] });
      }
    },
    [mediaInfo]
  );

  return {
    ...mediaInfo,
    fetchNextMediaSet,
  };
}
